import { AppBarProps } from '@mui/material'
import React, { useEffect } from 'react'

import { useGetTenantThemeQuery } from '@/services/api/tenant/tenantsEnhanced'
import { TenantData } from '../../../../core/types'
import { authSlice } from '../../../../features/auth'
import { useTypedDispatch } from '../../../../store'

type TenantMiddlewareProps = AppBarProps & {
  tenant: TenantData | null
  children: React.ReactNode
}

export const TenantMiddleware = ({ children, tenant }: TenantMiddlewareProps): JSX.Element => {
  const dispatch = useTypedDispatch()
  const tenantId = tenant?.id

  // Branding is loaded here rather than in the sidebar so every authenticated
  // surface — desktop, mobile, and all roles — gets it from one fetch.
  const { data: tenantTheme } = useGetTenantThemeQuery({ tenantId: tenantId ?? '' }, { skip: !tenantId })

  useEffect(() => {
    if (tenant) {
      dispatch(authSlice.actions.setCurrentTenant(tenant))
    }
  }, [tenant])

  useEffect(() => {
    if (tenantTheme) {
      dispatch(authSlice.actions.setTenantLogo(tenantTheme.logo_url || ''))
      dispatch(authSlice.actions.setTenantThemeColor(tenantTheme.color || ''))
    }
  }, [dispatch, tenantTheme])

  return <>{children}</>
}
